import React, { useState, useEffect } from "react";
import AlpacaLogo from "../assets/graphics/Alpaca_Logo.png";
import { Link } from "react-router-dom";
import { Drawer, Dropdown } from "antd";

import { MenuOutlined } from "@ant-design/icons";

export function NavBar(props) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const items = [
    {
      key: "1",
      label: <Link to="/modules/lucid-aware">Alpaca Aware</Link>,
    },
    {
      key: "2",
      label: <Link to="/modules/lucid-shop-floor">Alpaca Shop Floor</Link>,
    },
    {
      key: "3",
      label: (
        <Link to="/modules/lucid-visual-scheduler">
          Alpaca Visual Scheduler
        </Link>
      ),
    },
    {
      key: "4",
      label: <Link to="/modules/lucid-mrp">Alpaca MRP</Link>,
    },

    {
      key: "5",
      label: <Link to="/modules/lucid-quality">Alpaca Quality</Link>,
    },
    {
      key: "6",
      label: <Link to="/modules/lucid-warehouse">Alpaca Warehouse</Link>,
    },

    {
      key: "7",
      label: <Link to="/modules/compliance-app">Compliance App</Link>,
    },
  ];

  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <nav className={`nav ${scrolled ? "scrolled" : ""}`}>
      <div className="navInnerContainer">
        <div>
          <Link to="/">
            <img src={AlpacaLogo} className="navLogo" alt="Alpaca Logo" />
          </Link>
        </div>
        <div>
          <ul className="navLinks">
            <Link
              to="/about"
              style={{ textDecoration: "none", color: "black" }}
            >
              <li>About</li>
            </Link>
            <Dropdown
              menu={{
                items,
              }}
              placement="bottomLeft"
              zIndex={10000}
            >
              <li>Alpaca Modules</li>
            </Dropdown>
            <Link
              to="/services"
              style={{ textDecoration: "none", color: "black" }}
            >
              <li>Services</li>
            </Link>
            <a href="#form" style={{ color: "black" }}>
              <li>Contact</li>
            </a>
          </ul>
        </div>
        <div className="navBtnContainer">
          <a href="#form">
            <button className="main-btn">Get a Demo</button>
          </a>
        </div>

        <div className="mobileMenuBtnContainer" onClick={showDrawer}>
          <MenuOutlined />
        </div>
      </div>

      <Drawer
        onClose={onClose}
        open={open}
        title={
          <Link to="/">
            <img src={AlpacaLogo} style={{ width: "75%" }} alt="Alpaca Logo" />
          </Link>
        }
      >
        <ul className="navLinksMobile" onClick={onClose}>
          <Link to="/about" style={{ textDecoration: "none", color: "black" }}>
            <li>About</li>
          </Link>
          <Dropdown
            menu={{
              items,
            }}
            placement="bottomLeft"
            zIndex={10000}
          >
            <li>Alpaca Modules</li>
          </Dropdown>
          <Link
            to="/services"
            style={{ textDecoration: "none", color: "black" }}
          >
            <li>Services</li>
          </Link>
          <a href="#form" style={{ color: "black" }}>
            <li>Contact</li>
          </a>
        </ul>
      </Drawer>
    </nav>
  );
}
